import React from 'react';
export function Footer() {
  return <footer className="w-full bg-off-white px-5 py-10" data-id="element-86" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="3gfsmebmgesmg">
        <p className="font-serif-display text-base font-semibold text-slate" data-id="element-88" data-mp="3ggk88uq91bzj">
          NutriPro Complete System™
        </p>
        <p className="mt-2 text-xs leading-relaxed text-slate/50" data-id="element-89" data-mp="36pfu1x8edv5r">
          The premium digital clinical nutrition system for nutrition professionals worldwide. Instant Download · One-Time Payment · 14-Day Guarantee.
        </p>
        <p className="mt-4 text-xs text-slate/40" data-id="element-90" data-mp="38zbozae1d6l">
          © 2026 NutriPro Complete System™. All Rights Reserved.
        </p>
      </div>
    </footer>;
}